<template>
  <div>
    <div v-if="loading" class="uk-flex uk-flex-center spinner-top-padding">
      <spinner></spinner>
    </div>
    <div v-else>
      <div v-if="!resourceItems" class="container">
        <div class="uk-flex uk-flex-center">
          <img :src="icon">
        </div>
        <span class="uk-flex uk-flex-center heading-style">{{$t('pendingResources.nothingPending')}}</span>
        <div class="uk-flex uk-flex-center message-style">
      <span v-html="$t('pendingResources.makeSureTo')"></span>
        </div>
      </div>
      <div v-else>
        <div v-for="item in resourceItems">
          <result-item :lastPulledDate="lastPulledDate" :item="item" :key="item.contentId"></result-item>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import iconUtil from '../../../../utils/icon-util'
  import * as misc from '../../../../enums/misc'
  import resultItem from '../../../search/search-results/desktop/search-result-item'
  import {mapGetters} from 'vuex'
  import * as _ from 'lodash'
  import spinner from '../../../ui-components/spinner/spinner'

  export default {
    name: 'pending-resources',
    components: {
      resultItem,
      spinner
    },
    props: ['resources', 'lastPulledDate', 'loading'],
    data() {
      return {
        icon: iconUtil.resolve(misc.NO_PENDING_RESOURCES)
      }
    },
    methods: {
      openUrl(url) {
        window.open(url, '_blank')
      }
    },
    computed: {
      ...mapGetters(['getPendingResourcesPage']),
      resourceItems () {
        if (this.resources.length) {
          let start = 0
          let end = misc.PAGING_SIZE
          if (this.getPendingResourcesPage > 1) {
            end = misc.PAGING_SIZE * this.getPendingResourcesPage
            start = (end - misc.PAGING_SIZE)
          }
          return _.slice(this.resources, start, end)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../../../src/styles/colours';

  .container {
    margin-top: 100px;
  }
  .heading-style {
    font-size: 30px;
    font-weight: bold;
    color: $content-text;
    margin-top: 23px;
    text-align: center;
  }

  .message-style {
    /deep/
    a {
      font-size: 28px;
      font-weight: bold;
      color: $content-link-blue;
      &:hover {
        text-decoration: underline;
      }
    }
    font-size: 28px;
    color: $content-text;
    margin-top: 25px;
    text-align: center;
  }

  .spinner-top-padding {
    padding-top: 400px;
  }
</style>
